<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div *ngIf="merchant">
  <fieldset>
    <div class="main-row">
      <div class="col-md-12">
        <fieldset>
          <legend
            *ngIf="isWorldPay()"
            class="row"
            [ngStyle]="{ 'padding-top': !isWorldPay() ? '0' : '32px' }"
          >
            <div class="col-md-12">Payment Processor Information</div>
          </legend>
          <div class="mt-3">
            <div class="table-block">
              <div class="recordRow">
                <div class="recordLabel">Processor</div>
                <div id="Processor" class="recordValue">
                  {{ merchant.accountDetails.preferredProcessor }}
                </div>
              </div>
              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Merchant ID (External)</div>
                <div id="merchantIDExternal" class="recordValue">
                  {{ merchant.externalMerchantId }}
                </div>
              </div>
              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Worldpay UW Status</div>
                <div id="worldpayUWStatus" class="recordValue">
                  {{
                    merchant.accountDetails.worldPayAccountDetails
                      .worldpayUnderwritingStatus
                  }}
                </div>
              </div>
              <div class="recordRow">
                <div class="recordLabel">MMID (Internal)</div>
                <div id="MMIDInternal" class="recordValue">
                  {{ merchant.id }}
                </div>
              </div>
              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Vantiv IBM (MID)</div>
                <div id="vantivIBMMID" class="recordValue">
                  {{
                    merchant.accountDetails.worldPayAccountDetails.vantivIbmMid
                  }}
                </div>
              </div>
              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Terminal ID</div>
                <div id="vantivTID" class="recordValue">
                  {{
                    merchant.accountDetails.worldPayAccountDetails
                      .elementTerminalId
                  }}
                </div>
              </div>
              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Element Submerchant ID</div>
                <div id="subMerchantId" class="recordValue">
                  {{
                    merchant.accountDetails.worldPayAccountDetails.subMerchantId
                  }}
                </div>
              </div>
              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Account ID</div>
                <div id="elementAccountId" class="recordValue">
                  {{
                    merchant.accountDetails.worldPayAccountDetails
                      .elementAccountId
                  }}
                </div>
              </div>

              <div class="recordRow" *ngIf="isWorldPay()">
                <div class="recordLabel">Acceptor ID</div>
                <div id="elementAcceptorId" class="recordValue">
                  {{
                    merchant.accountDetails.worldPayAccountDetails
                      .elementAcceptorId
                  }}
                </div>
              </div>
              <div *ngIf="isWorldPay()">
                <div
                  class="recordRow"
                  *ngIf="
                    merchant.accountDetails.worldPayAccountDetails
                      .backingWPMerchantExists &&
                    merchant.accountDetails.worldPayAccountDetails
                      .worldpayUnderwritingStatus === 'Pending' &&
                    isMerchantActive
                  "
                >
                  <div
                    class="btn btn-primary {{
                      worldpayUnderwritingStatusInProgress
                        ? 'fa fa-spinner'
                        : ''
                    }}"
                    (click)="checkWorldpayUnderwritingStatus()"
                  >
                    Get Underwriting Status
                  </div>
                </div>
                <div
                  class="recordRow"
                  *ngIf="
                    merchant.accountDetails.worldPayAccountDetails
                      .backingWPMerchantExists &&
                    merchant.accountDetails.worldPayAccountDetails
                      .worldpayUnderwritingStatus === 'Declined'
                  "
                >
                  <div class="btn btn-primary disabled">
                    Get Underwriting Status
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </fieldset>
</div>
